<div class="app-update-wrapper">
  <p class="app-update-icon">🚀</p>
  <p class="app-update-heading">{{'app-update.update' | translate}}</p>
  <p class="app-update-content">{{'app-update.continue' | translate}}</p>
  <ion-button class="update-btn" (click)="updateMe()">{{'app-update.Update' | translate}}</ion-button>
</div>